interface MiniSparkBarProps {
  values: { label: string; value: number; color: string }[];
}

export const MiniSparkBar = ({ values }: MiniSparkBarProps) => {
  const total = values.reduce((sum, v) => sum + v.value, 0);
  if (total === 0) return null;

  return (
    <div className="space-y-2">
      <div className="flex h-4 rounded-full overflow-hidden bg-gray-100">
        {values.map((v) => {
          const pct = (v.value / total) * 100;
          if (pct === 0) return null;
          return (
            <div
              key={v.label}
              className="h-full transition-all duration-500 first:rounded-l-full last:rounded-r-full"
              style={{ width: `${pct}%`, backgroundColor: v.color }}
              title={`${v.label}: ${v.value} (${pct.toFixed(0)}%)`}
            />
          );
        })}
      </div>
      <div className="flex justify-between text-[10px] text-gray-500">
        <span>Precisa atenção: {values.filter((_, i) => i < 3).reduce((s, v) => s + v.value, 0)}</span>
        <span>OK: {values.filter((_, i) => i >= 3).reduce((s, v) => s + v.value, 0)}</span>
      </div>
    </div>
  );
};
